import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartComponentBase } from '../chart.types';
import { FormatNumberPipe } from 'app/shared/pipes/format-number.pipe';
import formatNumber from 'accounting-js/lib/formatNumber.js';
import { ColumnDef } from 'tsui/lib/ts-table/ts-table.model';
import { FieldDef } from '@core/models/account.types';
import { removeArchivedFieldsFromTableDefinition } from '@shared/functions/fields-functions';

@Component({
  selector: 'chart-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartTableComponent extends ChartComponentBase {
  /**
   * The sum. avg, count of the value
   */
  rowData: any[] = [];
  headers: string[] = [];
  columnDefs: ColumnDef[] = [];

  constructor(private readonly formatNumber: FormatNumberPipe) {
    super();
  }

  prepareChart(): void {
    const displayFields = removeArchivedFieldsFromTableDefinition(this.chartDef.display_fields, this.fields);
    this.columnDefs = displayFields.map((column) => {
      let colDef = this.lookupField(column);
      return {
        ...colDef,
        tsTableOptions: {
          headerName: colDef.label,
          // dots in the object key names will cause issues
          field: colDef.name.replace(/^related_to\./, 'related_to-'),
        },
        meta: {
          readonly: true,
        },
      };
    });

    this.rowData = Array.isArray(this.chartDef.data)
      ? this.chartDef.data
      : Object.keys(this.chartDef.data ?? {}).map((x) => this.chartDef.data[x]);
  }

  lookupField(name: string): FieldDef | undefined {
    return this.fields.find((fieldDef) => fieldDef.name === name);
  }

  private formatter(val: any): string {
    if (Number.isNaN(Number(val))) {
      return val;
    }

    if (this.chartDef.formatting && this.chartDef.formatting?.type) {
      if (this.chartDef.formatting?.type == 'number') {
        //return this.formatNumber.transform('23232223.45', 0);
        return formatNumber(val?.toString(), {
          precision: 0,
        });
      } else if (this.chartDef.formatting?.type == 'percent') {
        let formattedValue = formatNumber(val?.toString(), {
          precision: 2,
        });
        return formattedValue + '%';
      } else if (this.chartDef.formatting?.type == 'money') {
        let formattedValue = formatNumber(val?.toString(), {
          precision: 2,
        });
        return '$' + formattedValue;
      }
    } else {
      let formattedValue = formatNumber(val?.toString(), {
        precision: 2,
      });
      return formattedValue;
    }
  }
}
